
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function CTASection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.getElementById('cta-section');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const handleJoinGroup = () => {
    const formElement = document.getElementById('networking-form-section');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="cta-section" className="py-12 sm:py-16 lg:py-20 bg-black relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-5 left-5 sm:top-10 sm:left-10 w-20 h-20 sm:w-40 sm:h-40 border border-yellow-400 rounded-full"></div>
        <div className="absolute bottom-5 right-5 sm:bottom-10 sm:right-10 w-16 h-16 sm:w-32 sm:h-32 border border-yellow-400 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-30 h-30 sm:w-60 sm:h-60 border border-yellow-400 rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className={`text-center max-w-4xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight">
            El éxito no se construye{' '}
            <span className="text-yellow-400">solo.</span>
          </h2>
          
          <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 mb-8 sm:mb-12 leading-relaxed px-4">
            Conecta con las personas que pueden llevar tu negocio al siguiente nivel.
          </p>

          <div className="space-y-6 sm:space-y-8">
            <Button 
              size="lg" 
              onClick={handleJoinGroup}
              className="text-lg sm:text-xl lg:text-2xl px-8 sm:px-12 lg:px-16 py-4 sm:py-6 lg:py-8 shadow-2xl w-full sm:w-auto whitespace-nowrap"
            >
              <i className="ri-whatsapp-fill mr-2 sm:mr-3 lg:mr-4 text-xl sm:text-2xl lg:text-3xl"></i>
              Únete ahora al grupo de Networking VIP
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 text-gray-400">
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-fill text-yellow-400"></i>
                <span className="text-sm sm:text-base">100% Gratuito</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-time-fill text-yellow-400"></i>
                <span className="text-sm sm:text-base">Acceso inmediato</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-vip-crown-fill text-yellow-400"></i>
                <span className="text-sm sm:text-base">Comunidad exclusiva</span>
              </div>
            </div>
          </div>

          {/* Success Stories Preview */}
          <div className="mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-gray-900 rounded-lg p-4 sm:p-6 border border-yellow-400/20">
              <div className="flex items-center space-x-3 mb-3 sm:mb-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-user-fill text-black text-sm sm:text-base"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm sm:text-base">María González</p>
                  <p className="text-gray-400 text-xs sm:text-sm">Emprendedora</p>
                </div>
              </div>
              <p className="text-gray-300 text-xs sm:text-sm">
                "Gracias al networking encontré mi socio ideal y duplicamos nuestros ingresos."
              </p>
            </div>

            <div className="bg-gray-900 rounded-lg p-4 sm:p-6 border border-yellow-400/20">
              <div className="flex items-center space-x-3 mb-3 sm:mb-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-user-fill text-black text-sm sm:text-base"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm sm:text-base">Carlos Ruiz</p>
                  <p className="text-gray-400 text-xs sm:text-sm">Inversionista</p>
                </div>
              </div>
              <p className="text-gray-300 text-xs sm:text-sm">
                "La calidad de los contactos es excepcional. Cada conversación es una oportunidad."
              </p>
            </div>

            <div className="bg-gray-900 rounded-lg p-4 sm:p-6 border border-yellow-400/20">
              <div className="flex items-center space-x-3 mb-3 sm:mb-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-user-fill text-black text-sm sm:text-base"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm sm:text-base">Ana Martínez</p>
                  <p className="text-gray-400 text-xs sm:text-sm">CEO Startup</p>
                </div>
              </div>
              <p className="text-gray-300 text-xs sm:text-sm">
                "Conseguí funding para mi startup a través de un contacto del grupo."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
